/*@flow*/

export default (map: Leaflet$Map) => {
  // HACK:
  // see: https://github.com/Leaflet/Leaflet/issues/4125#issuecomment-183603719
  const c = map.getContainer();
  // HACK
  // see: https://github.com/facebook/flow/issues/3076#issuecomment-269172349
  (map: any).getContainer = () => {
    (c: any).focus = () => {};
    return c;
  };
};
